import { AttendanceType } from '@fingertip/creator-proto/gen/fingertip/common/enum/v1/attendance_type_pb'
import { EventLocationType } from '@fingertip/creator-proto/gen/fingertip/common/enum/v1/event_location_type_pb'
import { PaymentCollectionType } from '@fingertip/creator-proto/gen/fingertip/common/enum/v1/payment_collection_type_pb'
import { EventLocation } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/event_location_pb'

import {
  AttendanceTypeEnumType,
  LocationTypeEnumType,
  PaymentCollectionTypeEnumType,
} from '@/components/booking/types'
import { BookingLocation } from '@/lib/stores/booker-store'

export const attendanceTypeName = (
  attendanceType: AttendanceType | undefined,
): AttendanceTypeEnumType | undefined => {
  switch (attendanceType) {
    case AttendanceType.MEETING:
      return 'MEETING'
    case AttendanceType.GROUP:
      return 'GROUP'
    case AttendanceType.EVENT:
      return 'EVENT'
    case AttendanceType.UNSPECIFIED:
    default:
      return 'UNSPECIFIED'
  }
}

export const paymentCollectionTypeName = (
  paymentCollectionType: PaymentCollectionType | undefined,
): PaymentCollectionTypeEnumType | undefined => {
  switch (paymentCollectionType) {
    case PaymentCollectionType.CAPTURE_DETAILS:
      return 'CAPTURE_DETAILS'
    case PaymentCollectionType.POINT_OF_SALE:
      return 'POINT_OF_SALE'
    case PaymentCollectionType.COLLECT_UPFRONT:
      return 'COLLECT_UPFRONT'
    case PaymentCollectionType.FREE:
      return 'FREE'
    case PaymentCollectionType.UNSPECIFIED:
    default:
      return 'UNSPECIFIED'
  }
}

export const eventLocationTypeMappingName = (
  eventLocationType: EventLocationType,
): LocationTypeEnumType => {
  switch (eventLocationType) {
    case EventLocationType.UNSPECIFIED:
      return 'UNSPECIFIED'
    case EventLocationType.ATTENDEE_IN_PERSON:
      return 'ATTENDEE_IN_PERSON'
    case EventLocationType.HOST_IN_PERSON:
      return 'HOST_IN_PERSON'
    case EventLocationType.ATTENDEE_PHONE:
      return 'ATTENDEE_PHONE'
    case EventLocationType.HOST_PHONE:
      return 'HOST_PHONE'
    case EventLocationType.LINK:
      return 'LINK'
    case EventLocationType.CONFERENCING:
      return 'CONFERENCING'
  }
}

export const mappingNameToEventLocation = (name: LocationTypeEnumType) => {
  return {
    UNSPECIFIED: EventLocationType.UNSPECIFIED,
    ATTENDEE_IN_PERSON: EventLocationType.ATTENDEE_IN_PERSON,
    HOST_IN_PERSON: EventLocationType.HOST_IN_PERSON,
    ATTENDEE_PHONE: EventLocationType.ATTENDEE_PHONE,
    HOST_PHONE: EventLocationType.HOST_PHONE,
    LINK: EventLocationType.LINK,
    CONFERENCING: EventLocationType.CONFERENCING,
  }[name]
}

export const eventTypeLocationLabel = (
  eventLocationType: EventLocationType,
) => {
  return {
    [EventLocationType.UNSPECIFIED]: 'Unspecified',
    [EventLocationType.ATTENDEE_IN_PERSON]: "Host's address",
    [EventLocationType.HOST_IN_PERSON]: "Attendee's Address",
    [EventLocationType.ATTENDEE_PHONE]: "Attendee's phone",
    [EventLocationType.HOST_PHONE]: "Host's phone",
    [EventLocationType.LINK]: 'URL or Website',
    [EventLocationType.CONFERENCING]: 'Video conferencing',
  }[eventLocationType]
}

export const eventLocationToBookingLocationMapper = (
  eventLocation: EventLocation,
): BookingLocation => {
  return {
    label: eventTypeLocationLabel(eventLocation?.type),
    type: eventLocationTypeMappingName(eventLocation?.type),
    value: eventLocation?.value,
  }
}
